import { render, staticRenderFns } from "./taxExcludedCoinsStep.vue?vue&type=template&id=3fdc7774&"
import script from "./taxExcludedCoinsStep.vue?vue&type=script&lang=js&"
export * from "./taxExcludedCoinsStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports